<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row mb-3">
<!--          <div class="col-lg-12">-->
<!--            <v-expansion-panels flat popout hover>-->
<!--              <v-expansion-panel-->
<!--              >-->
<!--                <v-expansion-panel-header class="bg-light">-->
<!--                  <span><v-icon left>mdi-magnify</v-icon>Detaylı Arama</span>-->
<!--                </v-expansion-panel-header>-->
<!--                <v-expansion-panel-content>-->
<!--                  <div class="container-xxl-fluid">-->
<!--                    <div class="row">-->
<!--&lt;!&ndash;                      <div class="col-lg-3">&ndash;&gt;-->
<!--&lt;!&ndash;                        <v-text-field&ndash;&gt;-->
<!--&lt;!&ndash;                            v-model="currentCode"&ndash;&gt;-->
<!--&lt;!&ndash;                            label="Cari Kodu"&ndash;&gt;-->
<!--&lt;!&ndash;                            filled&ndash;&gt;-->
<!--&lt;!&ndash;                            solo&ndash;&gt;-->
<!--&lt;!&ndash;                            dense&ndash;&gt;-->
<!--&lt;!&ndash;                            clearable&ndash;&gt;-->
<!--&lt;!&ndash;                        ></v-text-field>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="col-lg-3">&ndash;&gt;-->
<!--&lt;!&ndash;                        <v-text-field&ndash;&gt;-->
<!--&lt;!&ndash;                            v-model="currentName"&ndash;&gt;-->
<!--&lt;!&ndash;                            label="Cari Adı"&ndash;&gt;-->
<!--&lt;!&ndash;                            filled&ndash;&gt;-->
<!--&lt;!&ndash;                            solo&ndash;&gt;-->
<!--&lt;!&ndash;                            dense&ndash;&gt;-->
<!--&lt;!&ndash;                            clearable&ndash;&gt;-->
<!--&lt;!&ndash;                        ></v-text-field>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--                      <div class="col-lg-3">-->
<!--                        <v-menu-->
<!--                            transition="scale-transition"-->
<!--                            offset-y-->
<!--                            :close-on-content-click="false"-->
<!--                            min-width="auto"-->
<!--                        >-->
<!--                          <template v-slot:activator="{ on, attrs }">-->
<!--                            <v-text-field-->
<!--                                :value="dateRangeStart"-->
<!--                                label="Tarih Aralık Başlangıç"-->
<!--                                prepend-inner-icon="mdi-calendar"-->
<!--                                readonly-->
<!--                                filled-->
<!--                                solo-->
<!--                                dense-->
<!--                                clearable-->
<!--                                @click:clear="dateRangeStart = null"-->
<!--                                v-bind="attrs"-->
<!--                                v-on="on"-->
<!--                            ></v-text-field>-->
<!--                          </template>-->
<!--                          <v-date-picker-->
<!--                              v-model="dateRangeStart"-->
<!--                              locale="tr"-->
<!--                          ></v-date-picker>-->
<!--                        </v-menu>-->
<!--                      </div>-->
<!--                      <div class="col-lg-3">-->
<!--                        <v-menu-->
<!--                            transition="scale-transition"-->
<!--                            offset-y-->
<!--                            :close-on-content-click="false"-->
<!--                            min-width="auto"-->
<!--                        >-->
<!--                          <template v-slot:activator="{ on, attrs }">-->
<!--                            <v-text-field-->
<!--                                :value="dateRangeEnd"-->
<!--                                label="Tarih Aralık Bitiş"-->
<!--                                prepend-inner-icon="mdi-calendar"-->
<!--                                readonly-->
<!--                                filled-->
<!--                                solo-->
<!--                                dense-->
<!--                                clearable-->
<!--                                @click:clear="dateRangeEnd = null"-->
<!--                                v-bind="attrs"-->
<!--                                v-on="on"-->
<!--                            ></v-text-field>-->
<!--                          </template>-->
<!--                          <v-date-picker-->
<!--                              v-model="dateRangeEnd"-->
<!--                              locale="tr"-->
<!--                          ></v-date-picker>-->
<!--                        </v-menu>-->
<!--                      </div>-->
<!--                      <div class="col-lg-12 text-end">-->
<!--                        <v-btn-->
<!--                            color="primary darken-1"-->
<!--                            @click="_fetchCurrentVisitList"-->
<!--                            small-->
<!--                        >-->
<!--                          <v-icon left>mdi-magnify</v-icon>-->
<!--                          Filtrele-->
<!--                        </v-btn>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </v-expansion-panel-content>-->
<!--              </v-expansion-panel>-->
<!--            </v-expansion-panels>-->
<!--          </div>-->
          <div class="col-lg-12 d-flex flex-wrap">
<!--            <div>-->
<!--              <p class="text-center">Gösterilen Kayıt Sayısı</p>-->
<!--              <v-btn-toggle mandatory solo dense>-->
<!--                <v-btn @click="perPage = 10"> 10 </v-btn>-->
<!--                <v-btn @click="perPage = 20"> 20 </v-btn>-->
<!--                <v-btn @click="perPage = 30"> 30 </v-btn>-->
<!--                <v-btn @click="perPage = 50"> 50 </v-btn>-->
<!--              </v-btn-toggle>-->
<!--            </div>-->
            <div class="ms-auto">
              <v-btn small color="success darken-1" @click="openNewCurrentVisitDialog">Ziyaret Ekle</v-btn>
            </div>
          </div>
        </div>
        <div class="row">
          <ResultsTableView :perPage="perPage"></ResultsTableView>
        </div>
        <!-- end row -->

<!--        <div class="row">-->
<!--          <div class="col-lg-12 mb-5">-->
<!--            <v-pagination-->
<!--                v-model="currentPage"-->
<!--                class="my-4"-->
<!--                :length="1"-->
<!--                :total-visible="20"-->
<!--            ></v-pagination>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <NewCurrentVisitDialog
        :showDialog="showNewCurrentVisitDialog"
        :processType="'new'"
        @dialogChange="(e) => (showNewCurrentVisitDialog = e)"
    ></NewCurrentVisitDialog>
  </div>

</template>

<script>
import {mapState, mapActions} from "vuex";
import NewCurrentVisitDialog from "@/components/current-visit/dialogs/NewVisitDialog.vue";
import ResultsTableView from "@/components/current-visit/results/ResultsTableView.vue";

export default {
  components: {
    ResultsTableView,
    NewCurrentVisitDialog
  },
  mounted() {
    this.selectedCurrentCodeFromRouter = this.$route.params.code;
    this.setSelectedCurrentCode(this.selectedCurrentCodeFromRouter);
    this._fetchCurrentVisitList();
  },
  computed: {
    ...mapState("visit", ["currentVisitList","selectedCurrentCode","selectedCurrentName"]),
    ...mapState("auth", ["user"]),
    ...mapState("cart", ["current"]),
  },
  data() {
    return {
      dataView: "ResultTableView",
      perPage: 10,
      currentPage: 1,
      // searchText: "",
      dateRangeStart: null,
      dateRangeEnd: null,
      showNewCurrentVisitDialog: false,
      selectedCurrentCodeFromRouter: null,
    };
  },
  methods: {
    ...mapActions("visit", ["fetchCurrentVisitList","setSelectedCurrentCode"]),
    async _fetchCurrentVisitList() {
       await this.fetchCurrentVisitList({
        params: {
          userId: this.user.UserId,
          currentCode: this.selectedCurrentCode
        },
        body: {}
      });
    },
    openNewCurrentVisitDialog() {
      this.showNewCurrentVisitDialog = true;
    },
  },

  watch: {
  },
};
</script>